export class CashRegisterZReportBulkVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  